import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from '../context/DispatchContext';
import Button from '../elements/Button';
import Label from '../elements/Label';
import FormikCheckBox from '../elements/formik/FormikCheckBox';
import FormikNumberInput from '../elements/formik/FormikNumberInput';
import { useAlert } from '../elements/popup/Alert';
import { MIN_AREA_POINTS, useCheckPointsNumberInWindowArea, } from '../hooks/useCheckPointsNumberInWindowArea';
import { headerLabelStyle } from './Header';
import { HeaderContainer } from './HeaderContainer';
const validationSchema = Yup.object().shape({
    minMaxRatio: Yup.number().min(0).required(),
});
const initialValues = {
    minMaxRatio: 0.05,
    lookNegative: false,
};
function RangesPickingOptionPanel() {
    const dispatch = useDispatch();
    const pointsNumber = useCheckPointsNumberInWindowArea();
    const alert = useAlert();
    function handleRangesPicking(values) {
        if (pointsNumber > MIN_AREA_POINTS) {
            dispatch({
                type: 'AUTO_RANGES_DETECTION',
                payload: values,
            });
        }
        else {
            alert.error(`Auto range picking only available for area more than ${MIN_AREA_POINTS} points`);
        }
    }
    return (_jsx(HeaderContainer, { children: _jsx(Formik, { onSubmit: handleRangesPicking, initialValues: initialValues, validationSchema: validationSchema, children: ({ handleSubmit, isValid }) => (_jsxs(_Fragment, { children: [_jsx(Label, { title: "Detect negative:", htmlFor: "lookNegative", style: headerLabelStyle, children: _jsx(FormikCheckBox, { name: "lookNegative" }) }), _jsx(Label, { title: "Min Max Ratio:", style: headerLabelStyle, children: _jsx(FormikNumberInput, { name: "minMaxRatio", style: {
                                width: '70px',
                            }, step: "0.01", min: 0 }) }), _jsx(Button.Done, { onClick: () => handleSubmit(), style: { margin: '0 10px' }, disabled: !isValid, children: "Auto ranges picking" })] })) }) }));
}
export default RangesPickingOptionPanel;
